import SettingSidebar from './SettingsSidebar'

export default SettingSidebar